import { useEffect } from "react";

type UseBarcodeAnimationEffectProps = {
  isVideoReady: boolean;
  tick: () => void;
  animationRef: React.MutableRefObject<number | undefined>;
};

export function useBarcodeAnimationEffect({
  isVideoReady,
  tick,
  animationRef,
}: UseBarcodeAnimationEffectProps) {
  useEffect(() => {
    if ("BarcodeDetector" in window && isVideoReady) {
      animationRef.current = requestAnimationFrame(tick);
      return () => {
        if (animationRef.current) cancelAnimationFrame(animationRef.current);
      };
    }
    return undefined;
  }, [tick, isVideoReady, animationRef]);
}
